import IconDropdownMenu from "../../../../ui/dropdownmenu/icondropdownmenu/icondropdownmenu";
import CategoryIcon from "../../../../modules/icons/category";
import {SimpleTable} from "../../../../modals/types/table";
import "./dashboard.scss";
import {useNavigate} from "react-router-dom";
import StatusCard from "../../../../ui/statuscard/statuscard";
import EyeIcon from "../../../../modules/icons/eye";
import ColumnChart from "../../../../ui/chart/column/columnchart";
import FallingChart from "../../../../modules/icons/fallingchart";
import UserContentHeader from "../../../user/header/usercontentheader/usercontentheader";
import RisingChartIcon from "../../../../modules/icons/risingchart";
import DollarIcon from "../../../../modules/icons/dollar";
import MonitorIcon from "../../../../modules/icons/monitor";
import {GuideIcon} from "../../../../modules/icons/guide";
import MouseIcon from "../../../../modules/icons/mouse";
import Table from "../../../../ui/table/table";

const Dashboard = () => {
    const navigate = useNavigate();
    const contentHeaderBox: JSX.Element = (
        <IconDropdownMenu icon={<CategoryIcon/>} title={'همه رسانه ها'} menuItems={
            [
                {
                    title: 'آیتم تست دراپ دون 1', action: () => {
                    }
                },
                {
                    title: 'آیتم تست دراپ دون 2', action: () => {
                    }
                },
            ]
        }/>
    )
    const tableData: SimpleTable = {
        headers: ["تاریخ", "نمایش ها", "نمایش دیده شده", "کلیک ها", "درآمد ناشر", "CPC", "CTR"],
        bodies: [
            ["1.148.892", "3 میلیون", "3 میلیون", "2 هزار", "2 هزار", "0.065%", "87.5%"],
            ["991.351", "3 میلیون", "3 میلیون", "2 هزار", "2 هزار", "0.065%", "108.4%"],
            ["991.351", "3 میلیون", "3 میلیون", "2 هزار", "2 هزار", "0.065%", "108.4%"],
            ["991.351", "3 میلیون", "3 میلیون", "2 هزار", "2 هزار", "0.065%", "108.4%"],
            ["991.351", "3 میلیون", "3 میلیون", "2 هزار", "2 هزار", "0.065%", "108.4%"],
            ["991.351", "3 میلیون", "3 میلیون", "2 هزار", "2 هزار", "0.065%", "108.4%"],
        ]
    }

    return (
        <div className="Publisher-Dashboard">
            {/*<DataNotFound image={require("../../../../assets/images/icons/DataNotFound.svg").default}*/}
            {/*              title={"داده ای برای نمایش وجود ندارد"}*/}
            {/*              body={"اگر داده ای برای گزارش وجود داشته باشد ، نمایش داده خواهد شد."}*/}
            {/*              makeBTN={true}*/}
            {/*              makeBTNText={"ساخت رسانه"}*/}
            {/*              makeBTNAction={() => {*/}
            {/*                  localStorage.setItem("createAdStation", "true");*/}
            {/*                  navigate("../publisher/ad-stations");*/}
            {/*              }}*/}
            {/*/>*/}
            <>
                <UserContentHeader title={'داشبورد مدیریت'} icon={<GuideIcon/>} iconColor={"#EF233C"}
                                   box={contentHeaderBox}/>
                <div className="row mt-4">
                    <div className="col-xl-3 col-lg-4 col-md-6 col-12 mb-3">
                        <StatusCard icon={<MouseIcon/>} type={"warning"} status={"124,622,456"} suffix={"ریال"}
                                    title={"متوسط نرخ کلیک"}
                                    subTitle={"10% افزایش نسبت به هفته گذشته"} chart={<RisingChartIcon/>}/>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6 col-12 mb-3">
                        <StatusCard icon={<MonitorIcon/>} type={"success"} status={"124,622,456"} suffix={"ریال"}
                                    title={"کل نمایش ها"}
                                    subTitle={"10% کاهش نسبت به هفته گذشته"} chart={<FallingChart/>}/>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6 col-12 mb-3">
                        <StatusCard icon={<EyeIcon/>} type={"info"} status={"3"} suffix={"کمپین فعال"}
                                    title={"نمایش دیده شده"}
                                    subTitle={"10% افزایش نسبت به هفته گذشته"} chart={<RisingChartIcon/>}/>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6 col-12 mb-3">
                        <StatusCard icon={<DollarIcon/>} type={"danger"} status={"124,622,456"} suffix={"ریال"}
                                    title={"CTR"}
                                    subTitle={"10% افزایش نسبت به هفته گذشته"} chart={<RisingChartIcon/>}/>
                    </div>
                </div>
                <ColumnChart title={"نمودار آمار رسانه ها"}/>
                <Table title={"رسانه های من"} headers={tableData.headers} bodies={tableData.bodies} rowEachPage={6}/>
            </>
        </div>
    );
}

export default Dashboard;